import BaseCtrl from 'edge/platform/base/BaseCtrl';
import LocalDateUtil from 'gw-portals-util-js/LocalDateUtil';

var fn = function fn($scope, submissionViewModel, ViewModelService, CPPCreditScoreService, $filter) {
    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();
    var newCreditScore = function newCreditScore(initialData) {
        return ViewModelService.create(initialData || {}, 'pc', 'ama.edge.capabilities.creditscore.dto.CreditScoreRequestDTO_AMA');
    };
    var createAddressLine1 = function createAddressLine1() {
        var streetDirection = false;
        var unitNumber = false;
        if ($scope.creditScoreVM.primaryAddress.streetNumber_CAA.value && $scope.creditScoreVM.primaryAddress.streetName_CAA.value && $scope.creditScoreVM.primaryAddress.streetType_CAA.value) /* &&
                                                                                                                                                                                                $scope.creditScoreVM.accountHolderPerson.primaryAddress.direction_CAA.value)*/{
                //Adding Street Direction if added
                if ($scope.creditScoreVM.primaryAddress.direction_CAA.value) {
                    streetDirection = true;
                    //$scope.creditScoreVM.accountHolderPerson.primaryAddress.addressLine1.value = `${$scope.creditScoreVM.accountHolderPerson.primaryAddress.unitNumber_CAA.value} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetNumber_CAA.value} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetName_CAA.value} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetType_CAA.value.code} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.direction_CAA.value.code}`;
                } else {
                    streetDirection = false;
                    //$scope.creditScoreVM.accountHolderPerson.primaryAddress.addressLine1.value = `${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetNumber_CAA.value} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetName_CAA.value} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetType_CAA.value.code}`;
                }
                //Adding Unit number if added
                if ($scope.creditScoreVM.primaryAddress.unitNumber_CAA.value) {
                    unitNumber = true;
                    //$scope.creditScoreVM.accountHolderPerson.primaryAddress.addressLine1.value = `${$scope.creditScoreVM.accountHolderPerson.primaryAddress.unitNumber_CAA.value} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetNumber_CAA.value} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetName_CAA.value} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetType_CAA.value.code} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.direction_CAA.value.code}`;
                } else {
                    unitNumber = false;
                    //$scope.creditScoreVM.accountHolderPerson.primaryAddress.addressLine1.value = `${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetNumber_CAA.value} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetName_CAA.value} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.streetType_CAA.value.code} ${$scope.creditScoreVM.accountHolderPerson.primaryAddress.direction_CAA.value.code}`;
                }

                $scope.creditScoreVM.primaryAddress.addressLine1.value = '' + (unitNumber ? $scope.creditScoreVM.primaryAddress.unitNumber_CAA.value + ' ' : '') + $scope.creditScoreVM.primaryAddress.streetNumber_CAA.value + ' ' + $scope.creditScoreVM.primaryAddress.streetName_CAA.value + ' ' + $scope.creditScoreVM.primaryAddress.streetType_CAA.value.code + (streetDirection ? ' ' + $scope.creditScoreVM.primaryAddress.direction_CAA.value.code : '');
            }
    };

    /**
     * Checks if any of additional fields is set
     * @returns {boolean}
     */
    /* function isAnyAdditionalField() {
        return OPTIONAL_ITEMS.some((itemName) => {
            return $scope.view[itemName] && $scope.view[itemName].value !== undefined;
        });
    }*/

    ctrl.init = function () {

        $scope.submissionVM = submissionVM;
        $scope.creditScoreVM = newCreditScore({
            publicID: submissionVM.baseData.accountHolder.publicID.value,
            firstName: submissionVM.baseData.accountHolder.firstName.value,
            lastName: submissionVM.baseData.accountHolder.lastName.value,
            dateOfBirth: submissionVM.baseData.accountHolder.dateOfBirth.value,
            accountNumberExt: submissionVM.baseData.accountHolder.accountNumberExt.value,
            accountPublicIDExt: submissionVM.baseData.accountHolder.accountPublicIDExt.value,
            primaryAddress: {
                publicID: submissionVM.baseData.accountHolder.primaryAddress.publicID.value,
                postalCode: submissionVM.baseData.accountHolder.primaryAddress.postalCode.value,
                addressType: submissionVM.baseData.accountHolder.primaryAddress.addressType.value.code,
                manualUpdIndicator_CAA: submissionVM.baseData.accountHolder.primaryAddress.manualUpdIndicator_CAA.value,
                incompleteAddress_CAA: submissionVM.baseData.accountHolder.primaryAddress.incompleteAddress_CAA.value,
                city: submissionVM.baseData.accountHolder.primaryAddress.city.value,
                state: submissionVM.baseData.accountHolder.primaryAddress.state.value.code,
                country: submissionVM.baseData.accountHolder.primaryAddress.country.value.code
            },
            producerCode: submissionVM.baseData.productCode.value,
            contactName: submissionVM.baseData.accountHolder.firstName.value + ' ' + submissionVM.baseData.accountHolder.lastName.value
        });

        $scope.submissionVM.baseData.accountHolder.consent_AMA = {
            value: false,
            aspects: {
                required: false,
                inputCtrlType: 'boolean',
                get valid() {
                    return true;
                }
            }
        };

        $scope.creditCheckOptions = [{
            value: 'more',
            displayValue: 'More than 2 years'
        }, {
            value: 'less',
            displayValue: 'Less than 2 years'
        }];

        $scope.creditCheckSelection = {
            value: null,
            aspects: {
                required: true,
                availableValues: $scope.creditCheckOptions,
                get valid() {
                    if ($scope.creditCheckSelection.value === '') {
                        return false;
                    }
                    return true;
                },
                get validationMessage() {
                    return $filter('translate')('policycommon.This is a required field');
                    //  return 'This is a required field';
                },
                get validationMessages() {
                    return [$filter('translate')('policycommon.This is a required field')];
                }
            }
        };

        $scope.creditCheckOptionToString = function (cc) {
            return cc.displayValue;
        };

        $scope.creditScoreVM.primaryAddress.isDiscountPage.value = true;

        $scope.nextButtonConfig = {
            class: 'button'
        };
        $scope.prevButtonConfig = {
            class: 'button--de-emphasized'
        };
    };

    ctrl.clearCreditValues = function () {
        if ($scope.submissionVM.baseData.accountHolder.consent_AMA && !$scope.submissionVM.baseData.accountHolder.consent_AMA.value) {
            $scope.creditCheckSelection.value = '';
            $scope.creditScoreVM.primaryAddress.streetNumber_CAA.value = undefined;
            $scope.creditScoreVM.primaryAddress.streetName_CAA.value = undefined;
            $scope.creditScoreVM.primaryAddress.streetType_CAA.value = undefined;
            $scope.creditScoreVM.primaryAddress.direction_CAA.value = undefined;
            $scope.creditScoreVM.primaryAddress.unitNumber_CAA.value = undefined;
        }
    };

    ctrl.checkConditions = function () {
        if (submissionVM.baseData.accountHolder.consent_AMA && submissionVM.baseData.accountHolder.consent_AMA.value && (!submissionVM.baseData.accountHolder.status || submissionVM.baseData.accountHolder.status.value === 'Not Available')) {
            return true;
        }
        return false;
    };

    ctrl.next = function (nextFn, form) {
        if ($scope.creditCheckSelection.value && $scope.creditCheckSelection.value.value !== 'none' && submissionVM.baseData.accountHolder.consent_AMA && submissionVM.baseData.accountHolder.consent_AMA.value && (!submissionVM.baseData.accountHolder.status || submissionVM.baseData.accountHolder.status.value === 'Not Available')) {
            createAddressLine1();
            CPPCreditScoreService.getCreditScore($scope.creditScoreVM.value).then(function (result) {
                if (result) {
                    nextFn(submissionVM, { valid: form.valid });
                }
            }).catch(function (error) {
                nextFn(submissionVM, { valid: form.valid });
            });
        } else {
            nextFn(submissionVM, { valid: form.valid });
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'submissionViewModel', 'ViewModelService', 'ama.CPPCreditScoreService', '$filter'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/controllers/CPPDiscountsCtrl.js
// module id = 824
// module chunks = 0